import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColLabelValue } from '../../../../../components/pdf/TableHelpers'
import Image from '../../../../../components/pdf/Image'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { mountValidityDateRange, getPlaceNames, findReplyByQuestionName } from '../../_helpers/pdfHelpers'

const CoverSection = ({ serviceOrder }) => {
  const placeNames = getPlaceNames(serviceOrder.place.name)

  const dateValidity = useMemo(() => {
    return mountValidityDateRange(serviceOrder)
  }, [serviceOrder])

  return (
    <View pageBreakAfter>
      <Separator weight={90} />
      <Text bold size="h4" align="center">
        BANCO SANTANDER (BRASIL) S.A.
      </Text>

      <Separator weight={15} />
      <Image src="/pdfs/bioqualynet/santander-logo.png" maxWidth={145} style={{ margin: 'auto' }} ignoreFixedSize />
      <Separator weight={15} />

      <Text bold size="h5" align="center">
        AÇÕES CORRETIVAS
      </Text>

      <Separator weight={15} />

      <Table width="70%" center>
        <TableRow>
          <TableColLabelValue label="UNIORG" value={placeNames.placeCode} />
        </TableRow>

        <TableRow>
          <TableColLabelValue label="NOME DO ESTABELECIMENTO" value={placeNames.placeName} />
        </TableRow>

        <TableRow>
          <TableColLabelValue
            label="DATA DA EMISSÃO"
            value={`${dateValidity.month}/${dateValidity.currentYear} - ${dateValidity.month}/${dateValidity.expiryYear}`}
          />
        </TableRow>

        <TableRow>
          <TableColLabelValue
            label="RESPONSÁVEL PELO PGR"
            value={findReplyByQuestionName(serviceOrder.replies, 'Representante da empresa').value.name}
          />
        </TableRow>
      </Table>

      <Separator weight={15} />

      <Text bold size="small" align="center">
        {`${dateValidity.month}/${dateValidity.currentYear}`}
      </Text>

      <Separator weight={120} />
    </View>
  )
}

export default CoverSection
